import fetch from '../utils/fetch';

// 智能表列表查询
export function getList(params) {
    return fetch({
        method: 'GET',
        url: 'waterwatt/payments',
        params
    })
}

// 设备详情查询
export function getDetails(params) {
    return fetch({
        method: 'GET',
        url: 'waterwatt/device/detail',
        params
    })
}

// 充值 POST
export function payment(data) {
    return fetch({
        method: 'POST',
        url: 'waterwatt/payment',
        data
    })
}

// 获取合同列表
export function getContract(params){
    return fetch({
        method: 'GET',
        url: 'contract/room',
        params
    })
}
// 获取合同列表（充电页面专用）
export function getContractRecharge(params){
  return fetch({
    method: 'GET',
    url: 'contract/roomRecharge',
    params
  })
}
